import {
    ADDRESS_LOOKUP_REQUEST, ADDRESS_LOOKUP_REQUEST_SUCCESS, ADDRESS_LOOKUP_REQUEST_FAILURE, ADD_DATA_BY_STREET_REQUEST, ADD_DATA_BY_STREET_REQUEST_SUCCESS, ADD_DATA_BY_STREET_REQUEST_FAILURE,
} from '../constants/address_lookup.constants';


export const addressLookupRequest = (params, data, method) => ({
    type: ADDRESS_LOOKUP_REQUEST, params, data, method,
});
export const addressLookupRequestSuccess = payload => ({ type: ADDRESS_LOOKUP_REQUEST_SUCCESS, payload });
export const addressLookupRequestFailure = error => ({ type: ADDRESS_LOOKUP_REQUEST_FAILURE, error });

export const addDataByStreetRequest = (data) => ({
    type: ADD_DATA_BY_STREET_REQUEST, data,
});
export const addDataByStreetRequestSuccess = payload => ({ type: ADD_DATA_BY_STREET_REQUEST_SUCCESS, payload });
export const addDataByStreetRequestFailure = error => ({ type: ADD_DATA_BY_STREET_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/address_lookup.actions.js